import { bool, shape, string, number } from 'prop-types';

// TODO: Needs revision after all payment methods are standarized
export const paymentMethodsPropTypes = shape({
  cash: bool,
  card: bool,
  online: bool,
  ingenico: bool,
  webpay: bool
});

export const subsidiaryPropTypes = shape({
  id: number,
  name: string,
  textAddress: string,
  latitude: string,
  longitude: string,
  deliveryWaitTime: number,
  pickUpWaitTime: number
});
